import { flushSync } from 'react-dom'

// Commits aria-invalid and aria-describedby before the focus moves, so a screen reader
// announces the field together with its error.
export function focusFirstInvalidField<TField>(
  validate: () => TField | null,
  inputIdOf: (field: TField) => string,
): boolean {
  const invalidField = flushSync(validate)
  if (!invalidField) {
    return false
  }

  document.getElementById(inputIdOf(invalidField)).focus()
  return true
}
